export const RecurringTerms = {
  monthly: 'monthly',
  annual: 'annual'
};